const Logo = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 64 64" className={className} xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="logo-grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: "#B05A2E" }} />
        <stop offset="60%" style={{ stopColor: "#D99465" }} />
        <stop offset="100%" style={{ stopColor: "#E5B472" }} />
      </linearGradient>
    </defs>
    {/* Abstract crystal / prism shape — represents creation & light */}
    <path
      d="M32 4L56 20V44L32 60L8 44V20L32 4Z"
      fill="none"
      stroke="url(#logo-grad)"
      strokeWidth="2.5"
      strokeLinejoin="round"
    />
    {/* Inner facets — depth & dimension */}
    <path
      d="M32 4L32 60M8 20L56 44M56 20L8 44"
      fill="none"
      stroke="url(#logo-grad)"
      strokeWidth="1.2"
      strokeLinejoin="round"
      opacity="0.35"
    />
    {/* Central bright node */}
    <circle cx="32" cy="32" r="5" fill="url(#logo-grad)" opacity="0.9" />
    {/* Corner accents */}
    <circle cx="32" cy="4" r="2.5" fill="url(#logo-grad)" opacity="0.7" />
    <circle cx="56" cy="20" r="2" fill="url(#logo-grad)" opacity="0.5" />
    <circle cx="56" cy="44" r="2" fill="url(#logo-grad)" opacity="0.5" />
    <circle cx="32" cy="60" r="2.5" fill="url(#logo-grad)" opacity="0.7" />
    <circle cx="8" cy="44" r="2" fill="url(#logo-grad)" opacity="0.5" />
    <circle cx="8" cy="20" r="2" fill="url(#logo-grad)" opacity="0.5" />
  </svg>
);

export default Logo;
